import { ProfitType } from 'pages/QuoteView/Quoting/RequestQuickQuote/types';
import { Maybe } from 'types/UtilityTypes';

export const TQL_DEFAULT_FLAT_MARGIN = 525;

export interface BatchDefaultProfit {
  defaultProfitType: ProfitType;
  defaultProfit: number;
}

export interface ResolveDefaultProfitTypeParams {
  inboxEmailAddress?: Maybe<string>;
  userDefaultMarginType?: Maybe<ProfitType>;
  serviceDefaultMarginType?: Maybe<string>;
}

export interface ResolveDefaultProfitParams {
  inboxEmailAddress?: Maybe<string>;
  userDefaultMargin?: Maybe<number>;
  userDefaultMarginType?: Maybe<ProfitType>;
  serviceDefaultMarginType?: Maybe<string>;
  serviceDefaultFlatMargin?: Maybe<number>;
  serviceDefaultPercentMargin?: Maybe<number>;
}

export function isTqlInboxEmail(inboxEmailAddress?: Maybe<string>): boolean {
  if (!inboxEmailAddress) {
    return false;
  }

  const at = inboxEmailAddress.lastIndexOf('@');
  if (at < 0) {
    return false;
  }

  const domain = inboxEmailAddress.slice(at + 1).toLowerCase();
  return domain === 'tql.com' || domain.endsWith('.tql.com');
}

export function resolveDefaultProfitType({
  inboxEmailAddress,
  userDefaultMarginType,
  serviceDefaultMarginType,
}: ResolveDefaultProfitTypeParams): ProfitType {
  if (userDefaultMarginType) {
    return userDefaultMarginType;
  }

  if (isTqlInboxEmail(inboxEmailAddress)) {
    return ProfitType.Amount;
  }

  return (serviceDefaultMarginType as ProfitType) || ProfitType.Percentage;
}

export function resolveDefaultProfit({
  inboxEmailAddress,
  userDefaultMargin,
  userDefaultMarginType,
  serviceDefaultMarginType,
  serviceDefaultFlatMargin,
  serviceDefaultPercentMargin,
}: ResolveDefaultProfitParams): number {
  if (userDefaultMargin) {
    return userDefaultMargin;
  }

  const profitType = resolveDefaultProfitType({
    inboxEmailAddress,
    userDefaultMarginType,
    serviceDefaultMarginType,
  });

  if (profitType === ProfitType.Amount) {
    if (isTqlInboxEmail(inboxEmailAddress) && !userDefaultMarginType) {
      return TQL_DEFAULT_FLAT_MARGIN;
    }

    return serviceDefaultFlatMargin || 100;
  }

  return serviceDefaultPercentMargin || 10;
}
